import { useTranslation } from "react-i18next";
import { FormatCurrencyForDisplay, SkeletonLoader } from "@unified-checkout/design-system";
import type { IMetrics } from "@app/dashboard/types/innerLayout/metrics";
import MetricCard from "./MetricCard";
import styles from "./metrics.module.scss";

export const Metrics = ({
  data,
  isLoading = false,
  isError = false,
  errorText,
  comparisonRangeName,
  noOfCards
}: IMetrics) => {
  const { t } = useTranslation();

  return (
    <div className={styles["metrics"]}>
      {
        (data || Array.from({ length: noOfCards })).map((item: any, i: number) =>
          isError ?
            <MetricCard
              key={`metric-card-error-${i}`}
              errorText={errorText || t('innerLayout.errors.unableToRetrieveData')}
            />
            :
            (
              isLoading ?
                <SkeletonLoader noOfRows={3} key={`metric-card-loader-${i}`} />
                :
                data ?
                  <MetricCard
                    key={`metric-card-${i}`}
                    title={item.title}
                    hint={item.info}
                    amount={
                      item.currency ? (
                        <>
                          {FormatCurrencyForDisplay(item.currency)}
                          {' '}{item.value}
                        </>
                      ) : item.value
                    }
                    percentage={item.comparison?.percentage}
                    comparisonText={
                      (comparisonRangeName && item.comparison) ?
                        `${t('innerLayout.homePage.metricCards.vs')} ${comparisonRangeName}`
                        :
                        ''
                    }
                    status={item.comparison?.status}
                  />
                  :
                  <SkeletonLoader noOfRows={3} key={`metric-card-loader-${i}`} />
            )
        )
      }
    </div>
  )
}